export const integrations = [
  {
    name: "Front-end integration",
    description:
      "Running the advertising platform on data from the customers website.",
    propertyKey: "frontEnd"
  },
  {
    name: "API integration",
    description:
      "Running the advertising platform on data from the customers system(s).",
    propertyKey: "apiIntegration"
  },
  {
    name: "Single sign-on",
    description:
      "Single sign-on is an authentication scheme that allows a user to log in with a single ID to any of several related, yet independent, software systems.",
    propertyKey: "sso"
  },
  {
    name: "Customer data platform",
    description:
      "Connect data to enhance audiences, obtain insights and enrich the customer experience.",
    propertyKey: "cdp"
  },
  {
    name: "Campaign data API",
    description:
      "Monitor order placements and create custom reporting for unique insights.",
    propertyKey: "campaignData"
  },
  {
    name: "CRM lead routing",
    description: "Route Lead Capture leads to the CRM instead of via emails.",
    propertyKey: "crmLeadRouting"
  }
];

export const defaultValues = integrations.reduce((acc, integration) => {
  acc[integration.propertyKey] = false;
  return acc;
}, {} as Record<string, boolean>);
